<div class="mb-3">
  <div>All fields optional</div>
  <mat-form-field class="me-3">
    <input
      matInput
      placeholder="Start Date"
      [matDatepicker]="startPicker"
      [(ngModel)]="startDate"
    />
    <mat-datepicker-toggle matSuffix [for]="startPicker" />
    <mat-datepicker #startPicker />
  </mat-form-field>
  <mat-form-field class="me-3">
    <input
      matInput
      placeholder="End Date"
      [matDatepicker]="endPicker"
      [(ngModel)]="endDate"
    />
    <mat-datepicker-toggle matSuffix [for]="endPicker" />
    <mat-datepicker #endPicker />
  </mat-form-field>
  <mat-form-field class="me-3">
    <mat-label>Type</mat-label>
    <input matInput type="text" [(ngModel)]="type" />
    @if (type) {
      <button
        type="button"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="type = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
  <mat-form-field class="me-3">
    <mat-label>Limit</mat-label>
    <input matInput type="text" [(ngModel)]="limit" />
    <mat-hint>Default: 500</mat-hint>
    @if (limit) {
      <button
        type="button"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="limit = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>

  <button
    type="button"
    mat-raised-button
    color="primary"
    class="mx-auto me-3"
    (click)="getAudits()"
  >
    Get Report
  </button>

  @if (!loading && auditData) {
    <div class="my-3">
      <button
        type="button"
        mat-raised-button
        color="primary"
        class="mx-auto me-3"
        [disabled]="selectedIds.length === 0"
        (click)="retryAudits()"
      >
        Retry Selected
      </button>
      <button
        type="button"
        mat-raised-button
        color="primary"
        class="mx-auto me-3"
        [disabled]="selectedIds.length === 0"
        (click)="deleteAudits()"
      >
        Delete Selected
      </button>
    </div>

    <kendo-grid
      kendoGridSelectBy="id"
      [kendoGridBinding]="auditData"
      [pageSize]="25"
      [pageable]="true"
      [selectable]="{ mode: 'multiple', checkboxOnly: true }"
      [navigable]="true"
      [(selectedKeys)]="selectedIds"
    >
      <kendo-grid-checkbox-column [width]="40" />
      @for (col of gridColumns; track $index) {
        <kendo-grid-column [field]="col" />
      }
    </kendo-grid>
  }
  <ngx-loading [show]="loading" />
</div>
